module.exports = __webpack_public_path__ + "static/media/obligation-pastor.fef5f7f2.jpg";